// Add your custom JS here.
jQuery(function ($) {
    let isScrolled = false;

    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const header = $("header.header-site");

        if (!isScrolled && scroll > 60) {
            isScrolled = true;
            header.addClass("scrolled");
        } else if (isScrolled && scroll < 20) {
            isScrolled = false;
            header.removeClass("scrolled");
        }
    });
});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Search Bar Expanded functionality
document.addEventListener("DOMContentLoaded", function () {
    const searchIconBtn = document.querySelector(".search-icon-btn");
    const searchBarExpanded = document.getElementById("searchBarExpanded");
    const searchCloseBtn = document.querySelector(".search-close-btn");
    const searchInput = searchBarExpanded
        ? searchBarExpanded.querySelector(
              "input[type='search'], input[type='text']",
          )
        : null;
    const searchSuggestions = document.getElementById("searchSuggestions");
    let searchTimeout;

    if (searchIconBtn && searchBarExpanded) {
        // Open search bar
        searchIconBtn.addEventListener("click", function (e) {
            e.preventDefault();
            searchBarExpanded.classList.add("active");
            // Focus on the search input
            if (searchInput) {
                setTimeout(() => searchInput.focus(), 100);
            }
        });

        // Close search bar
        if (searchCloseBtn) {
            searchCloseBtn.addEventListener("click", function (e) {
                e.preventDefault();
                searchBarExpanded.classList.remove("active");
            });
        }

        // Close search bar when pressing Escape
        document.addEventListener("keydown", function (e) {
            if (
                e.key === "Escape" &&
                searchBarExpanded.classList.contains("active")
            ) {
                searchBarExpanded.classList.remove("active");
            }
        });

        // Close search bar when clicking outside
        searchBarExpanded.addEventListener("click", function (e) {
            if (e.target === searchBarExpanded) {
                searchBarExpanded.classList.remove("active");
            }
        });

        // Search suggestions functionality
        if (searchInput && searchSuggestions) {
            searchInput.addEventListener("input", function () {
                const query = this.value.trim();

                clearTimeout(searchTimeout);

                if (query.length < 2) {
                    searchSuggestions.classList.remove("show");
                    searchSuggestions.innerHTML = "";
                    return;
                }

                // Show loading state
                searchSuggestions.innerHTML =
                    '<div class="search-loading">Searching...</div>';
                searchSuggestions.classList.add("show");

                // Use WordPress admin-ajax with debounce
                searchTimeout = setTimeout(() => {
                    const ajaxUrl =
                        typeof searchAjax !== "undefined"
                            ? searchAjax.ajaxUrl
                            : "/wp-admin/admin-ajax.php";
                    const nonce =
                        typeof searchAjax !== "undefined"
                            ? searchAjax.nonce
                            : "";
                    const formData = new FormData();
                    formData.append("action", "search_posts");
                    formData.append("search", query);
                    if (nonce) {
                        formData.append("nonce", nonce);
                    }

                    fetch(ajaxUrl, {
                        method: "POST",
                        body: formData,
                    })
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error(
                                    `HTTP error! status: ${response.status}`,
                                );
                            }
                            return response.json();
                        })
                        .then((data) => {
                            console.log("Search response:", data);
                            if (
                                !data.success ||
                                !data.data ||
                                data.data.length === 0
                            ) {
                                searchSuggestions.innerHTML =
                                    '<div class="search-no-results">No results found</div>';
                                return;
                            }

                            let html = "";
                            data.data.forEach((item) => {
                                const title = item.post_title || "No title";
                                const url = item.guid || "#";

                                html += `
                                    <a href="${url}" class="search-suggestion-item">
                                        <span class="suggestion-title">${title}</span>
                                    </a>
                                `;
                            });

                            searchSuggestions.innerHTML = html;

                            // Close search bar when clicking on a result
                            searchSuggestions
                                .querySelectorAll(".search-suggestion-item")
                                .forEach((item) => {
                                    item.addEventListener("click", function () {
                                        searchBarExpanded.classList.remove(
                                            "active",
                                        );
                                    });
                                });
                        })
                        .catch((error) => {
                            console.error(
                                "Error fetching search results:",
                                error,
                            );
                            searchSuggestions.innerHTML =
                                '<div class="search-no-results">Error searching. Please try again.</div>';
                        });
                }, 300); // 300ms debounce
            });

            // Close suggestions when clicking outside
            document.addEventListener("click", function (e) {
                if (
                    !searchInput.contains(e.target) &&
                    !searchSuggestions.contains(e.target)
                ) {
                    searchSuggestions.classList.remove("show");
                }
            });
        }
    }
});

//slider logos
document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll(".slider-logos__slider")
        .forEach(function (slider) {
            new Swiper(slider, {
                loop: true,
                slidesPerView: 2,
                spaceBetween: 70,
                allowTouchMove: false,
                speed: 4000,
                freeMode: {
                    enabled: true,
                    momentum: false,
                },
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
                breakpoints: {
                    400: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 50,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                    1280: {
                        slidesPerView: 7,
                    },
                    1440: {
                        slidesPerView: 9,
                    },
                },
            });
        });
});

// Case Study Slider
document.addEventListener("DOMContentLoaded", function () {
    const sliderEl = document.querySelector(".slider-featured__slider");
    if (!sliderEl) return;

    new Swiper(sliderEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 800,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".slider-featured__next",
            prevEl: ".slider-featured__prev",
        },
        pagination: {
            el: ".slider-featured__pagination",
            clickable: true,
        },
    });
});

// Related Case Studies Slider
(function () {
    function initRelatedCaseStudies() {
        document
            .querySelectorAll(".related-case-studies")
            .forEach(function (section) {
                var sliderEl = section.querySelector(".swiper-case-studies");
                var nextBtn = section.querySelector(".rcs-btn-next");
                var prevBtn = section.querySelector(".rcs-btn-prev");

                if (!sliderEl || !nextBtn || !prevBtn) return;
                if (sliderEl._swiper) return;

                sliderEl._swiper = new Swiper(sliderEl, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: false,
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                    breakpoints: {
                        992: { slidesPerView: 3, spaceBetween: 30 },
                        768: { slidesPerView: 2, spaceBetween: 30 },
                    },
                });
            });
    }

    document.addEventListener("DOMContentLoaded", initRelatedCaseStudies);
})();

// Filter events
jQuery(document).ready(function ($) {
    function updateFilterSlider($activeBtn) {
        var $slider = $activeBtn
            .closest(".filter-toggle")
            .find(".filter-slider");
        $slider.css({
            width: $activeBtn.outerWidth() + "px",
            transform: "translateX(" + ($activeBtn[0].offsetLeft - 9) + "px)",
        });
    }

    function loadEvents(type, animate) {
        var $container = $("#events-container");
        var $btns = $(".filter-events .filter-btn");
        var $activeBtn = $btns.filter('[data-value="' + type + '"]');

        if (!$activeBtn.length) return;

        $btns.removeClass("active");
        $activeBtn.addClass("active");

        if (animate) {
            updateFilterSlider($activeBtn);
        } else {
            var $slider = $activeBtn
                .closest(".filter-toggle")
                .find(".filter-slider");
            $slider.css("transition", "none");
            updateFilterSlider($activeBtn);
            setTimeout(function () {
                $slider.css("transition", "");
            }, 50);
        }

        $container
            .addClass("is-loading")
            .append(
                '<div class="events-loading-overlay"><div class="events-spinner"></div></div>',
            );

        $.ajax({
            url: eventsAjax.ajax_url,
            type: "POST",
            data: {
                action: "filter_events",
                event_type: type,
                limit: $container.data("limit") || 4,
            },
            success: function (response) {
                $container.removeClass("is-loading").html(response);
            },
            error: function () {
                $container
                    .removeClass("is-loading")
                    .html("<p>Error loading events.</p>");
            },
        });
    }

    function getQueryParam(name) {
        return new URLSearchParams(window.location.search).get(name);
    }

    function resyncSlider() {
        var $activeBtn = $(".filter-events .filter-btn.active");
        if (!$activeBtn.length) return;
        var $slider = $activeBtn
            .closest(".filter-toggle")
            .find(".filter-slider");
        $slider.css("transition", "none");
        updateFilterSlider($activeBtn);
        setTimeout(function () {
            $slider.css("transition", "");
        }, 50);
    }

    var resizeTimer;
    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resyncSlider, 100);
    });

    // Init: read from URL or default to 'upcoming'
    var initialType = getQueryParam("events") || "upcoming";
    loadEvents(initialType, false);

    $(".filter-events .filter-btn").on("click", function () {
        var type = $(this).data("value");
        var params = new URLSearchParams(window.location.search);
        params.set("events", type);
        history.pushState(null, "", "?" + params.toString());
        loadEvents(type, true);
    });

    // Handle browser back/forward
    $(window).on("popstate", function () {
        var type = getQueryParam("events") || "upcoming";
        loadEvents(type, true);
    });
});

// Results Stats counters
document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll(".results-stats");
    if (!sections.length) return;

    const ABBREVIATED_SUFFIXES = ["K", "M", "B", "T"];

    function animateCounter(el, duration) {
        if (el.dataset.counterDone) return;
        el.dataset.counterDone = "true";

        const raw = el.dataset.counterTarget;
        const hasCommas = raw.includes(",");
        const cleanRaw = raw.replace(/,/g, "");
        const target = parseFloat(cleanRaw);
        if (isNaN(target)) return;

        const numberEl = el.closest(".stat-card__number");
        const suffixEl = numberEl
            ? numberEl.querySelector(".stat-card__suffix")
            : null;
        const suffixKey = suffixEl
            ? suffixEl.textContent.trim().toUpperCase()
            : "";
        const isAbbreviated = ABBREVIATED_SUFFIXES.includes(suffixKey);

        // Abbreviated suffixes animate with 1 decimal; decimals in raw value are respected
        const decimals =
            isAbbreviated && !cleanRaw.includes(".")
                ? 1
                : cleanRaw.includes(".")
                  ? cleanRaw.split(".")[1].length
                  : 0;

        const start = performance.now();

        function update(now) {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = eased * target;

            if (progress < 1) {
                let valStr =
                    decimals > 0
                        ? current.toFixed(decimals).replace(/\.0+$/, "")
                        : Math.round(current).toString();

                if (hasCommas) {
                    const parts = valStr.split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    valStr = parts.join(".");
                }

                el.textContent = valStr;
                requestAnimationFrame(update);
            } else {
                el.textContent = raw;
            }
        }

        requestAnimationFrame(update);
    }

    sections.forEach(function (section) {
        const valueEls = section.querySelectorAll(".stat-card__value");
        if (!valueEls.length) return;

        const animatableEls = [];

        valueEls.forEach(function (el) {
            const raw = el.textContent.trim();
            const regex = /(\d{1,3}(?:,\d{3})+|\d+(?:\.\d+)?|[^\d.]+)/g;
            const tokens = raw.match(regex);

            if (tokens) {
                // Clear the element's content
                el.innerHTML = "";

                tokens.forEach(function (token) {
                    const cleanToken = token.trim();
                    const numVal = parseFloat(cleanToken.replace(/,/g, ""));

                    if (!isNaN(numVal)) {
                        // Create a sub-span for the number part
                        const span = document.createElement("span");
                        span.className = "stat-number-part";
                        span.dataset.counterTarget = cleanToken;
                        span.textContent = "0";
                        el.appendChild(span);
                        animatableEls.push(span);
                    } else {
                        // Create a sub-span for the non-number part (e.g. hyphen)
                        const span = document.createElement("span");
                        span.className = "stat-text-part";
                        span.textContent = token;
                        el.appendChild(span);
                    }
                });
            } else {
                el.dataset.counterDone = "true";
            }
        });

        let started = false;
        function startCounters() {
            if (started) return;
            started = true;
            animatableEls.forEach(function (el) {
                animateCounter(el, 2000);
            });
        }

        const observer = new IntersectionObserver(
            function (entries, obs) {
                if (!entries[0].isIntersecting) return;
                obs.disconnect();
                startCounters();
            },
            { threshold: 0.15 },
        );

        observer.observe(section);
    });
});
/**
 * Hero Banner Anchor Links (`data-anchor-nav` / `data-anchor-link`)
 * Ported from osint-combine smooth hash scroll + scroll-based active state.
 */
(function () {
    "use strict";

    function getScrollOffset() {
        return window.innerWidth < 992 ? 180 : 230;
    }

    function scrollToHash(hash, behavior) {
        var el = document.querySelector(hash);
        if (!el) {
            return;
        }

        setTimeout(function () {
            window.scrollTo({
                top:
                    el.getBoundingClientRect().top +
                    window.pageYOffset -
                    getScrollOffset(),
                behavior: behavior || "smooth",
            });
        }, 50);
    }

    function getHashFromLink(link) {
        var href = link.getAttribute("href") || "";

        if (href.charAt(0) === "#") {
            return href;
        }

        if (link.dataset.anchorTarget) {
            return "#" + link.dataset.anchorTarget;
        }

        try {
            var url = new URL(href, window.location.href);
            if (
                url.origin === window.location.origin &&
                url.pathname === window.location.pathname &&
                url.hash
            ) {
                return url.hash;
            }
        } catch (e) {
            return "";
        }

        return "";
    }

    function resolveTarget(link) {
        var hash = getHashFromLink(link);
        if (!hash || hash.length < 2) {
            return null;
        }
        return document.querySelector(hash);
    }

    function initAnchorNav(nav) {
        var links = Array.prototype.slice.call(
            nav.querySelectorAll("[data-anchor-link]"),
        );

        if (!links.length) {
            return;
        }

        var targets = [];

        links.forEach(function (link) {
            var target = resolveTarget(link);
            if (target) {
                targets.push({ link: link, target: target });
            }
        });

        if (!targets.length) {
            return;
        }

        function setActive(index) {
            links.forEach(function (link) {
                link.classList.remove("is-active");
                link.removeAttribute("aria-current");
            });

            if (index >= 0 && index < targets.length) {
                targets[index].link.classList.add("is-active");
                targets[index].link.setAttribute("aria-current", "location");
            }
        }

        function getActiveIndex() {
            var scrollY = window.scrollY;
            var headerOffset = getScrollOffset();
            var activeIndex = 0;

            for (var i = 0; i < targets.length; i++) {
                var rect = targets[i].target.getBoundingClientRect();
                var absoluteTop = rect.top + scrollY;

                if (absoluteTop - headerOffset <= scrollY) {
                    activeIndex = i;
                }
            }

            return activeIndex;
        }

        function syncActiveFromScroll() {
            setActive(getActiveIndex());
        }

        links.forEach(function (link) {
            link.addEventListener("click", function (event) {
                var hash = getHashFromLink(link);

                if (!hash || hash.length < 2) {
                    return;
                }

                var target = document.querySelector(hash);
                if (!target) {
                    return;
                }

                event.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash, "smooth");

                var index = targets.findIndex(function (item) {
                    return item.link === link;
                });

                if (index >= 0) {
                    setActive(index);
                }
            });
        });

        setTimeout(syncActiveFromScroll, 100);

        window.addEventListener("scroll", syncActiveFromScroll, {
            passive: true,
        });

        window.addEventListener("resize", syncActiveFromScroll);

        window.addEventListener("hashchange", function () {
            if (!window.location.hash) {
                return;
            }

            scrollToHash(window.location.hash, "smooth");
            syncActiveFromScroll();
        });

        if (window.location.hash) {
            scrollToHash(window.location.hash, "auto");
            setTimeout(syncActiveFromScroll, 100);
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll("[data-anchor-nav]").forEach(initAnchorNav);
    });
})();

// Swiper Testimonials

document.addEventListener("DOMContentLoaded", function () {
    var testimonialWrappers = document.querySelectorAll(
        ".testimonials-slider-wrapper",
    );
    testimonialWrappers.forEach(function (wrapper) {
        var swiperElement = wrapper.querySelector(".swiper-testimonials");
        if (!swiperElement) return;

        var slides = swiperElement.querySelectorAll(".swiper-slide");
        if (slides.length <= 1) {
            return;
        }

        var nextBtn = wrapper.querySelector(".swiper-button-next");
        var prevBtn = wrapper.querySelector(".swiper-button-prev");

        new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                },
            },
        });
    });
});
(function () {
    var resizeTimer;

    function positionGuideHeroGlow() {
        var page =
            document.querySelector(".page-single-guide") ||
            document.querySelector(".page-single-resources-common");
        if (!page) {
            return;
        }

        var anchor =
            page.querySelector(".guide-hero__figure") ||
            page.querySelector(".guide-hero__media-inner");
        if (!anchor) {
            return;
        }

        var pageRect = page.getBoundingClientRect();
        var anchorRect = anchor.getBoundingClientRect();
        var centerX = anchorRect.left + anchorRect.width / 2 - pageRect.left;

        page.style.setProperty("--guide-glow-left", centerX + "px");
        page.style.setProperty("--guide-glow-translate", "-50%");
        page.classList.add("guide-glow-positioned");
    }

    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(positionGuideHeroGlow, 100);
    }

    document.addEventListener("DOMContentLoaded", positionGuideHeroGlow);
    window.addEventListener("resize", onResize);
    window.addEventListener("load", positionGuideHeroGlow);

    if (typeof jQuery !== "undefined") {
        jQuery(document).on("sf:ajaxfinish", positionGuideHeroGlow);
    }
})();

//Add Event Calendar
const addToCalendarBtn = document.getElementById("add-to-calendar");
if (addToCalendarBtn) {
    addToCalendarBtn.addEventListener("click", function () {
        const btn = this;
        const title = btn.getAttribute("data-title");
        const start = btn.getAttribute("data-start");
        const end = btn.getAttribute("data-end");

        const icsContent = [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "BEGIN:VEVENT",
            `SUMMARY:${title}`,
            `DTSTART:${start}`,
            `DTEND:${end}`,
            "END:VEVENT",
            "END:VCALENDAR",
        ].join("\r\n");

        const blob = new Blob([icsContent], {
            type: "text/calendar;charset=utf-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", "event.ics");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}

/* Gravity Forms File Upload - Change button text to filename */
document.addEventListener("DOMContentLoaded", function () {
    const fileInputs = document.querySelectorAll(
        '.gfield--type-fileupload input[type="file"]',
    );

    fileInputs.forEach(function (input) {
        const container = input.closest(".ginput_container_fileupload");

        if (container) {
            const originalText = "Upload";
            // Initialize data-text if not present
            if (!container.getAttribute("data-text")) {
                container.setAttribute("data-text", originalText);
            }

            input.addEventListener("change", function () {
                if (this.files && this.files.length > 0) {
                    let fileName = this.files[0].name;
                    if (fileName.length > 25) {
                        fileName = fileName.substring(0, 15) + "...";
                    }
                    container.setAttribute("data-text", fileName);
                } else {
                    container.setAttribute("data-text", originalText);
                }
            });
        }
    });
});

// Search input clear button
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('input[type="search"]').forEach(function (input) {
        if (input.dataset.clearInit) return;
        input.dataset.clearInit = "true";

        var wrap = document.createElement("div");
        wrap.className = "search-field-wrap";
        input.parentNode.insertBefore(wrap, input);
        wrap.appendChild(input);

        input.setAttribute("autocomplete", "off");

        var clearBtn = document.createElement("button");
        clearBtn.type = "button";
        clearBtn.className = "search-field-clear";
        clearBtn.setAttribute("aria-label", "Clear search text");
        clearBtn.textContent = "Clear";
        wrap.appendChild(clearBtn);

        function toggleClear() {
            clearBtn.style.display =
                input.value.length > 0 ? "inline-block" : "none";
        }

        input.addEventListener("input", toggleClear);
        toggleClear();

        clearBtn.addEventListener("click", function () {
            input.value = "";
            toggleClear();
            input.focus();
            input.dispatchEvent(
                new Event("input", {
                    bubbles: true,
                }),
            );
        });
    });
});

// Anchor link handling for general sections (e.g. in hero banner)
function setupAnchorElements() {
    var elements = document.querySelectorAll(
        ".general-section > .container[id]",
    );

    elements.forEach(function (el) {
        var id = el.id;

        if (!id || !id.trim()) {
            return;
        }

        if (document.getElementById(id) !== el) {
            return;
        }

        var spacer = document.createElement("span");
        spacer.id = id;
        spacer.className = "js-anchor-spacer";

        el.removeAttribute("id");
        el.parentNode.insertBefore(spacer, el);
    });
}

function getAnchorOffset() {
    if (window.innerWidth >= 992 && window.innerHeight <= 800) {
        return 190;
    }

    return 200;
}

function scrollToAnchor(hash) {
    if (!hash || hash === "#") return;

    var target;

    try {
        target = document.querySelector(hash);
    } catch (e) {
        return;
    }

    if (!target) return;

    var top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        getAnchorOffset();

    window.scrollTo({
        top: Math.max(0, top),
        behavior: "auto",
    });
}

function scrollToAnchorAfterLayout(hash) {
    var delays = [100, 250, 500, 750, 1000];
    var cancelled = false;

    function cancel() {
        cancelled = true;

        window.removeEventListener("wheel", cancel);
        window.removeEventListener("touchstart", cancel);
        window.removeEventListener("keydown", cancel);
    }

    window.addEventListener("wheel", cancel, { passive: true });
    window.addEventListener("touchstart", cancel, { passive: true });
    window.addEventListener("keydown", cancel);

    delays.forEach(function (delay) {
        setTimeout(function () {
            if (cancelled) return;

            requestAnimationFrame(function () {
                scrollToAnchor(hash);
            });

            if (delay === delays[delays.length - 1]) {
                cancel();
            }
        }, delay);
    });
}

setupAnchorElements();

window.addEventListener("load", function () {
    if (!window.location.hash) return;

    scrollToAnchorAfterLayout(window.location.hash);
});

window.addEventListener("hashchange", function () {
    scrollToAnchorAfterLayout(window.location.hash);
});

document.addEventListener(
    "click",
    function (event) {
        var link = event.target.closest('a[href*="#"]');

        if (!link) return;

        var url = new URL(link.href, window.location.href);

        if (url.pathname !== window.location.pathname) return;
        if (url.hostname !== window.location.hostname) return;
        if (!url.hash || url.hash === "#") return;

        var target;

        try {
            target = document.querySelector(url.hash);
        } catch (e) {
            return;
        }

        if (!target) return;

        event.preventDefault();

        if (window.location.hash !== url.hash) {
            history.pushState(null, "", url.hash);
        }

        scrollToAnchorAfterLayout(url.hash);
    },
    true,
);
